import { FormSelect } from 'components/common';
import { ISelectOption } from 'components/common/Select/types';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { addAddressQuestions } from '../questions';
import { IFullAddressAdditionProps } from './types';

export const FullAddressAddition: FC<IFullAddressAdditionProps> = ({
  addressOptions,
  onLinkClick,
  isManual,
  value,
  requiredFieldErrorMessage,
}) => {
  return (
    <>
      <div className={'mt-8'}>
        <FormattedMessage id={addAddressQuestions.fullAddress.labelKey} tagName={'h4'} />
        <FormSelect
          name={'fullAddress'}
          rules={{ required: !isManual && requiredFieldErrorMessage }}
          options={addressOptions}
          selectProps={{
            isOptionEqualToValue: (option: ISelectOption, selectedOptionValue: string) =>
              option.value === selectedOptionValue,
            value,
          }}
          selectInputProps={{ InputLabelProps: { shrink: true } }}
        />
      </div>
      <p className={'mt-7 cursor-pointer font-semibold text-sky-500 underline'} onClick={onLinkClick}>
        <FormattedMessage id={'applicationForm.ADD_ADDRESS.cantFindAddress'} />
      </p>
    </>
  );
};
